export default __webpack_public_path__ + "static/media/place.54548047.png";